module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-2"
    }
  }, [_c('p', {
    staticClass: "subhead1c"
  }, [_vm._v("FAMILY HISTORY FROM PEN & SWORD BOOKS")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Birth, Marriage & Death Records")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Family History Web Directory")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing British Battalions on the Somme")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Great War Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing History Through Title Deeds")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Secret Service Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing the Rifle Volunteers")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Air Force Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors from 1066 to 1837")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors Through Death Records – Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors through Family Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors Through Letters and Personal Writings")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors Using DNA")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors Using the Census")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Ancestors: Cambridgeshire, Essex, Norfolk and Suffolk")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Aristocratic Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Army Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Army Ancestors – Third Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Birmingham Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Black Country Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Boer War Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your British Indian Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Canal Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Channel Islands Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Church of England Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Criminal Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Docker Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your East Anglian Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your East End Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Family History on the Internet")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Female Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your First World War Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Freemason, Friendly Society and")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trade Union Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Georgian Ancestors, 1714–1837")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Glasgow Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Great War Ancestors: The Gallipoli Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Great War Ancestors: The Somme")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Great War Ancestors: Ypres")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Huguenot Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Insolvent Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Irish Family History on the Internet")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Jewish Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Jewish Ancestors – Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Labour Movement Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Legal Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Liverpool Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Liverpool Ancestors – Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your London Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Medical Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Merchant Navy Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Northern Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Northern Irish Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Northern Irish Ancestors – Second")]), _vm._v(" Edition")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Oxfordshire Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Pauper Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Police Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Potteries Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Pre-Victorian Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Prisoner of War Ancestors: The First")]), _vm._v(" World War")]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Railway Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Roman Catholic Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Royal Marine Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Rural Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Scottish Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Second World War Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Servant Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Service Women Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Shipbuilding Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Tank Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Textile Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Twentieth-Century Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Welsh Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your West Country Ancestors")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tracing Your Yorkshire Ancestors Writing Your Family History")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Your Irish Ancestors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6d47314","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/002_About_the_author.vue
// module id = 60
// module chunks = 0